export default function NAS() {
    return (
        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M26.6388 6.75391H5.90095C5.08287 6.75391 4.41968 7.4171 4.41968 8.23518V24.0354C4.41968 24.8535 5.08287 25.5167 5.90095 25.5167H26.6388C27.4569 25.5167 28.1201 24.8535 28.1201 24.0354V8.23518C28.1201 7.4171 27.4569 6.75391 26.6388 6.75391Z"
                stroke="black"
                strokeWidth="1.48127"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M10.345 6.75391L10.345 25.5167" stroke="black" strokeWidth="1.48127" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16.27 6.75391V25.5167" stroke="black" strokeWidth="1.48127" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M22.1951 6.75391V25.5167" stroke="black" strokeWidth="1.48127" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M22.1951 10.7036H24.1701" stroke="black" strokeWidth="1.48127" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16.27 10.7036H18.2451" stroke="black" strokeWidth="1.48127" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.345 10.7036H12.32" stroke="black" strokeWidth="1.48127" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="7.38229" cy="21.5666" r="0.987517" fill="black" />
        </svg>
    );
}
